<template>
  <div class="top-component">
    <div>
      <div class="name-style">{{ name }}, {{ nowDateString }}好 ~</div>
      <div class="time-style">今天是 {{ todaytime }} {{ week }}</div>
    </div>
    <div class="IP-style">上次登录IP: {{ lastLoginIP }}</div>
  </div>
</template>

<script>
export default {
  name: 'HelloComponent',
  data() {
    return {
      name: '',
      todaytime: '',
      nowDateString: '',
      lastLoginIP: ''
    }
  },
  mounted() {
    if (localStorage.user) {
      this.name = JSON.parse(localStorage.user).info.userName
      // console.log("name",this.name,JSON.parse(localStorage.user).info)
      let param = JSON.parse(localStorage.user).info.userId
      this.$http
        .get('/sctm/user/getUserLastLoginIp', { params: { userId: param } })
        .then(res => {
          if (res.data.returnCode == 0) {
            // console.log("res.data.bean",res.data.bean);
            this.todaytime = res.data.bean.nowDate
            this.lastLoginIP = res.data.bean.lastLoginIp
            this.nowDateString = res.data.bean.nowDateString
          } else {
            this.$Message.error(res.data.returnMessage)
          }
        })
    } else {
      this.$router.push('/login')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.top-component {
  padding: 36px 36px;
  background-color: #ffff;
  height: 162px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .name-style {
    font-size: 30px;
    margin-bottom: 20px;
    font-weight: 600;
    color: #33344a;
  }
  .time-style {
    font-size: 16px;
    color: #5e5f77;
  }
  .IP-style {
    color: #c5cde0;
    font-size: 14px;
    float: right;
  }
}
</style>
